module.exports = __webpack_public_path__ + "img/FoggyAndRain.dde10a75.png";